module.exports = __webpack_public_path__ + "img/thumb_aula33.55afa54b.jpg";